import * as React from "react";
import styled from "styled-components";
import { BaseSVG } from "../../BaseSVG";

const AutoplayIconWrapper = styled(BaseSVG)`
  overflow: visible;
`;

export const AutoplayIcon = props => (
  <AutoplayIconWrapper viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M12,4.25 C7.71979319,4.25 4.25,7.71979319 4.25,12 C4.25,16.2802068 7.71979319,19.75 12,19.75 C16.2802068,19.75 19.75,16.2802068 19.75,12 C19.75,9.9203542 18.93087,8.03202646 17.5976482,6.64005495 L19.4502803,4.96037299 C21.1858412,6.79652999 22.25,9.2739912 22.25,12 C22.25,17.6609187 17.6609187,22.25 12,22.25 C6.33908131,22.25 1.75,17.6609187 1.75,12 C1.75,6.33908131 6.33908131,1.75 12,1.75 L12,-2 L17,3 L12,8 L12,4.25 Z M15,12 L10,15 L10,9 L15,12 Z" />
    </g>
  </AutoplayIconWrapper>
);
